module.exports = __webpack_public_path__ + "img/index_lableIcon2.d5a0177a.png";